import { render } from "./doctorScheduleDurationSelector.vue?vue&type=template&id=128b36fe&scoped=true"
import script from "./doctorScheduleDurationSelector.vue?vue&type=script&lang=js"
export * from "./doctorScheduleDurationSelector.vue?vue&type=script&lang=js"

import "./doctorScheduleDurationSelector.vue?vue&type=style&index=0&id=128b36fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128b36fe"]])

export default __exports__